import { Badge } from "reactstrap"
import { dateISO, eventColorSelection } from "@lib/util"

// ** Expandable row component
const ExpandableRow = ({ data }) => {
  return (
    <div className="expandable-content p-5 border-bottom-light border-start-primary border-end-light border-5">
      <div className="d-flex justify-content-between gap-3">
        <div>
          <div className="d-flex">
            <div style={{ pointerEvents: "none" }}>
              <Badge
                color={`light-${eventColorSelection(data.eventReason.id)}`}
                pill
                className="me-1"
              >
                {data.eventReason.name}
              </Badge>
            </div>
            {data.amount > 0 && (
              <div>
                <span>
                  {data.currency.iso3} {data.amount}
                </span>
              </div>
            )}
          </div>
          <p className="fw-bold py-2">{data.description}</p>
        </div>
      </div>
      <div className="pt-3 text-muted d-flex gap-4 border-top-light">
        <div>
          <h6>Event date:</h6>
          <span>{dateISO(data.on, true, true)}</span>
        </div>
        <div>
          <h6>Created:</h6>
          <span>{dateISO(data.createdOn, true, true)}</span>
        </div>
        <div>
          <h6>Last update:</h6>
          <span>{dateISO(data.updatedOn, true, true)}</span>
        </div>
      </div>
    </div>
  )
}
export default ExpandableRow
